(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wct-mobile-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wct-mobile-buy')) {
  customElements.define('wct-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector('button');
      this.root = document.getElementById('ProductInfo-' + this.dataset.section);
      if (!this.root) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.submit = () => {
        const original = document.getElementById('ProductSubmitButton-' + this.dataset.section);
        if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
        original.click();
      };
      this.control.addEventListener('click', this.submit);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, characterData: true });
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      document.addEventListener('click', this.schedule);
      this.schedule();
    }
    sync() {
      const original = document.getElementById('ProductSubmitButton-' + this.dataset.section);
      if (!original) { this.hidden = true; return; }
      const label = original.querySelector('span')?.textContent.trim() || original.textContent.trim();
      if (this.control.textContent !== label) this.control.textContent = label;
      this.control.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      const blocked = [...document.body.classList].some(name => name.startsWith('overflow-hidden')) ||
        [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active')].some(el => el.getClientRects().length && el.getAttribute('aria-hidden') !== 'true');
      this.hidden = window.innerWidth > 749 || original.getBoundingClientRect().bottom >= 0 || blocked;
      const error = this.root.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (error && error.textContent.trim() && !this.hidden) {
        this.hidden = true;
        error.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.bodyObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      document.removeEventListener('click', this.schedule);
      this.control?.removeEventListener('click', this.submit);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
